import React, { useEffect } from 'react';
import {
  Box,
  HStack,
  VStack,
  useColorModeValue,
  Link,
  Text,
  Button,
  Center,
  ChakraProvider,
  Spinner
} from '@chakra-ui/react';
import {
  ArrowForwardIcon
} from '@chakra-ui/icons';
import { useState } from 'react';
// import 'react-quill/dist/quill.snow.css';
import Cookies from 'universal-cookie';
import moment from 'moment';

import './Home.css';
import AppShell from '../../components/AppShell';
import QuillEditor from '../../components/QuillEditor';
import {PostItem} from "../../interfaces"
import { useNavigate } from 'react-router-dom';
import { calculateSize, calculateTitleSize } from '../../helpers';

const Home = () => {
  // !!! B E G I N   A U T H   B L O C K !!! //
  const [isAuthed, setIsAuthed] = useState(false);
  const cookies = new Cookies(null, { path: '/' });
  
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }

  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);

  useEffect(() => {
    let token = cookies.get("token")
    if (token === undefined) {
      token = ""
    }

    fetch(location.protocol + '//' + location.host + '/authenticated/' + token)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setIsAuthed(data["isAuthed"]);
      });
    }, [])
    // !!! E N D   A U T H   B L O C K !!! //

  return (
    <ChakraProvider>
      <AppShell isAuthed={isAuthed}>

        {isAuthed && <NewPostWriter width={width}/>}  {/* SHOULD ONLY BE VISIBLE FOR ADMINS */}
        <BlogPage width={width} isAuthed={isAuthed}/>
      </AppShell>
    </ChakraProvider>
  )
}


interface NewPostWriterProps {
  width: number
}

const NewPostWriter = ({width}: NewPostWriterProps) => {
  const [isNewPostWriterOpen, setIsNewPostWriterOpen] = useState(false);
  const cookies = new Cookies(null, { path: '/' });

  const navigate = useNavigate(); 

  const submitPost = (title: string, value: string) => {
      let token = cookies.get("token")
      if (token === undefined) {
        token = ""
      }
      
      fetch(location.protocol + '//' + location.host + '/create/post', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "title": title,
          "contents": value,
          "token": token
        })
      })
      .then((res) => {
        if (res.status === 200) {
          alert("Post successfully created!")
          navigate(".", {
            replace: true,
            state: {
              commentWriter: false,
              postEditor: false,
            }
          });
          window.location.reload();
        } else {
          alert("Failed to create post.")
        }
      })
  }

  const onClickButton = () => {
    setIsNewPostWriterOpen(!isNewPostWriterOpen)
  }
  
  return (
    <>
      <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
        <Button
            rightIcon={<ArrowForwardIcon />}
            variant='solid'
            color='white'
            backgroundColor='green'
            size='lg'
            onClick={onClickButton}
        >
            New Post
        </Button>
      </Box>
      {isNewPostWriterOpen && <QuillEditor onSubmit={submitPost} topText={"New Post"} topTextSize="large" hasTitleField={true} p='4' m='20' width={width}/>}
    </>
  )
}

// # PostItem:
// #     postId: str               | PRIMARY KEY
// #     timestamp: str (DDMMYYYY) | SECONDARY KEY
// #     pinned: bool
// #     title: str
// #     contents: str
// #     comments: list[CommentItem]
// #     
// # CommentItem:
// #     commentId: str
// #     timestamp: str (DDMMYYYY)
// #     pinned: bool
// #     contents: str
// #     replies: list[ReplyItem]
// #
// #
// # ReplyItem:
// #     replyId: str
// #     timestamp: str (DDMMYYYY)
// #     contents: str

// interface ReplyItem {
//   replyId: string,
//   timestamp: string,
//   contents: string,
// }

// interface CommentItem {
//   commentId: string,
//   timestamp: string,
//   pinned: boolean,
//   contents: string,
//   replies: ReplyItem[]
// }

// interface PostItem {
//   postId: string,
//   timestamp: string,
//   pinned: boolean,
//   title: string,
//   contents: string,
//   comments: CommentItem[]
// }

interface BlogPageProps {
  width: number
  isAuthed: boolean
}

const BlogPage = ({width, isAuthed}: BlogPageProps) => {
  const [postData, setPostData] = useState([]);
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    fetch(location.protocol + '//' + location.host + '/get/posts')
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setPostData(data
          .sort((a: PostItem, b: PostItem) => Number(a.timestamp) > Number(b.timestamp) ? -1 : 1)
          .sort((a: PostItem, b: PostItem) => Number(a.pinned) > Number(b.pinned) ? -1 : 1)
        );
      });
  }, []);

  useEffect(() => {
    if (postData.length !== 0) {
      setIsLoading(false)
    }
  }, [postData])

    return (
      <>
        {isLoading &&
          <Center>
            <VStack>
              <Spinner size={"xl"} color="red"/>
              <Text><b>Loading...</b></Text>
            </VStack>
          </Center>
        }
        {!isLoading &&
            <VStack alignItems='start' width='100%'>
                {postData != null && postData.length != 0 && (postData).map((postItem: PostItem) => 
                  <PostItem postItem={postItem} width={width} isAuthed={isAuthed} key={postItem.postId}/>
                )}
            </VStack>
        }
      </>
    );
};

interface PostItemProps {
  postItem: PostItem
  width: number
  isAuthed: boolean
}

const PostItem = ({postItem, width, isAuthed}: PostItemProps) => {
  const cookies = new Cookies(null, { path: '/' });

  const TEXT_PADDING = "10px"
  const ITEM_HEIGHT = "40vh"
  const ITEM_HEIGHT_NUM = 40
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)

  const navigate = useNavigate(); 
  const navigateToPost = (postId: string, isCommentWriterOpen: boolean, isPostEditorOpen: boolean) =>{ 
    const path = `/post/${postId}`; 
    navigate(path, {
      state: {
        commentWriter: isCommentWriterOpen,
        postEditor: isPostEditorOpen,
      }
    });
  }

  const submitDeletePost = (postId: string) => {
    let token = cookies.get("token")
    if (token === undefined) {
      token = ""
    }
      
    setShowDeleteConfirmation(false)
    fetch(location.protocol + '//' + location.host + '/delete/post', {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "postId": postId,
        "token": token
      })
    })
    .then((res) => {
      if (res.status === 200) {
        alert("Post successfully deleted!")
        navigate(".", {
          replace: true,
          state: {
            commentWriter: false,
            postEditor: false,
          }
        });
        window.location.reload();
      } else {
        alert("Failed to delete post.")
      }
    })
  }

  const submitPinPost = (postId: string) => {
    let token = cookies.get("token")
    if (token === undefined) {
      token = ""
    }
      
    fetch(location.protocol + '//' + location.host + '/pin/post', {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "postId": postId,
        "pinned": !postItem.pinned,
        "token": token
      })
    })
    .then((res) => {
      if (res.status === 200) {
        alert("Post successfully pinned / unpinned!")
        navigate(".", {
          replace: true,
          state: {
            commentWriter: false,
            postEditor: false,
          }
        });
        window.location.reload();
      } else {
        alert("Failed to pin post.")
      }
    })
  }

  const editClicked = () => {
    navigateToPost(postItem.postId, false, true)
    return
  }

  const deleteClicked = () => {
    setShowDeleteConfirmation(!showDeleteConfirmation)
    return
  }

  const pinClicked = () => {
    submitPinPost(postItem.postId)
    return
  }

  const commentClicked = () => {
    navigateToPost(postItem.postId, true, false)
    return
  }

  const postClicked = () => {
    navigateToPost(postItem.postId, false, false)
  }

  return (
  <>
    <Box
      minW='100%'
      maxW='100%'
      minH={ITEM_HEIGHT}
      maxH={ITEM_HEIGHT}
      borderWidth="1px"
      borderColor={useColorModeValue('black', 'gray.900')}
      backgroundColor={postItem.pinned ? "lightyellow" : "white"}
      style={{textOverflow: 'ellipsis'}}>
        <VStack
          alignItems={'start'}
          minW='100%'
          maxW='100%'
          minH={ITEM_HEIGHT}
          maxH={ITEM_HEIGHT}
          p="10"
        >
          <HStack 
            minW='100%'
            maxW='100%'
            minH={ITEM_HEIGHT_NUM * 0.5}
            maxH={ITEM_HEIGHT_NUM * 0.5}>
            <VStack 
              minW='80%'
              maxW='80%'
              alignItems={'start'}>
              <Link pl={TEXT_PADDING} pr={TEXT_PADDING} pb={"0px"} fontSize={calculateTitleSize(postItem.title.length, width)} onClick={() => postClicked()}>
                {postItem.pinned ? "(PINNED) | " : ""}<b>{postItem.title}</b>
              </Link>
              <Text pl={TEXT_PADDING} pr={TEXT_PADDING} pb={TEXT_PADDING} fontSize={calculateSize(18, width)}>
                Posted {moment(new Date(Number(postItem.timestamp) * 1000)).format("MMMM Do YYYY, hh:mm:ss")} : {postItem.postId}
              </Text>
            </VStack>
            <VStack
              minW="20%"
              maxW="20%"
              alignItems="end">
              {isAuthed && 
                <HStack>
                  <Link onClick={() => editClicked()} fontSize={calculateSize(18, width)}>
                    Edit
                  </Link>
                  <Link onClick={() => deleteClicked()} fontSize={calculateSize(18, width)}>
                    Delete
                  </Link>
                  <Link onClick={() => pinClicked()} fontSize={calculateSize(18, width)}>
                    Pin
                  </Link>
                </HStack>
              }
            </VStack>
          </HStack>
          <Text
            p={TEXT_PADDING}
            fontSize={calculateSize(18, width)}
            minH={ITEM_HEIGHT_NUM * 0.6}
            maxH={ITEM_HEIGHT_NUM * 0.6}
            style={{textOverflow: 'clip', whiteSpace: 'normal', overflow: 'hidden'}}>
              <div dangerouslySetInnerHTML={{__html: postItem.contents}} />
          </Text>
          <VStack
            minW="100%"
            maxW="100%"
            alignItems="end"
            minH={ITEM_HEIGHT_NUM * 0.2}
            maxH={ITEM_HEIGHT_NUM * 0.2}>
            <HStack>
              <Link onClick={() => commentClicked()} fontSize={calculateSize(18, width)}>
                Comment
              </Link>
            </HStack>
          </VStack>

          
        </VStack>
      </Box>
      <>
        {showDeleteConfirmation &&
          <Box style={{
            "position": "fixed",
            "top": "50%",
            "left": "50%",
            "transform": "translate(-50%, -50%)",
            "backgroundColor": "whitesmoke",
            "padding": "20px",
            "borderRadius": "5px",
            "boxShadow": "0 2px 5px rgba(0, 0, 0, 0.2)",
            "width": "500px", "height": "125px"}}>
              <VStack>
                <Center>
                  <VStack>
                    <Text fontSize={calculateSize(18, width)}>
                      <b>Are you sure you want to delete this post?</b>
                    </Text>
                    <Text fontSize={calculateSize(18, width)}>
                      <b>Post ID: {postItem.postId}</b>
                    </Text>
                  </VStack>
                </Center>
                <HStack>
                  <Button
                        rightIcon={<ArrowForwardIcon />}
                        variant="solid"
                        color='white'
                        backgroundColor='red'
                        size='sm'
                        onClick={() => setShowDeleteConfirmation(!showDeleteConfirmation)}
                    >
                    Cancel
                  </Button>
                  <Button
                        rightIcon={<ArrowForwardIcon />}
                        variant="solid"
                        color='white'
                        backgroundColor='green'
                        size='sm'
                        onClick={() => submitDeletePost(postItem.postId)}
                    >
                    Delete
                  </Button>
                </HStack>
              </VStack>
          </Box>
        }
      </>
    </>
  );
};

export default Home;